import { useFrame } from "@react-three/fiber"
import { useRef } from "react"
import type { Group, Mesh } from "three"
import { scenePresence, sectionFocus, smoothstep, type LandingMotionRef } from "../lib/landing-motion"
import { applyGroupOpacity } from "../lib/three"
import { SceneText } from "./SceneText"

export function DashboardTour({ motion }: { motion: LandingMotionRef }) {
  const group = useRef<Group>(null)
  const sweepRef = useRef<Mesh>(null)

  useFrame(() => {
    const section = motion.current.section
    const presence = scenePresence(section, 4.42, 6.58, 0.46)
    const focus = sectionFocus(section, 5, 0.92)
    if (!group.current) return
    group.current.position.set(1.88 - focus * 0.12, -0.1, -0.72 + presence * 0.72)
    group.current.rotation.x = -0.04 + focus * 0.05
    group.current.rotation.y = -0.46 + smoothstep(4.62, 6.22, section) * 0.72
    group.current.scale.setScalar(1.28 + focus * 0.14)
    applyGroupOpacity(group.current, presence)
    if (sweepRef.current) {
      sweepRef.current.position.y = 0.82 - smoothstep(4.78, 5.9, section) * 1.62
    }
  })

  return (
    <group ref={group} scale={1.38}>
      <mesh>
        <boxGeometry args={[3.4, 2, 0.08]} />
        <meshBasicMaterial color="#0b1412" transparent opacity={0.72} />
      </mesh>
      <mesh position={[0, 0.86, 0.07]}>
        <boxGeometry args={[3.32, 0.16, 0.035]} />
        <meshBasicMaterial color="#14d8b4" transparent opacity={0.16} />
      </mesh>
      <mesh position={[0.62, 0.18, 0.08]}>
        <boxGeometry args={[1.42, 1.12, 0.035]} />
        <meshBasicMaterial color="#10221f" transparent opacity={0.78} />
      </mesh>
      <mesh position={[0.62, 0.18, 0.11]}>
        <planeGeometry args={[1.22, 0.82]} />
        <meshBasicMaterial color="#14d8b4" wireframe transparent opacity={0.3} />
      </mesh>
      <mesh ref={sweepRef} position={[0.62, 0.82, 0.13]}>
        <boxGeometry args={[1.32, 0.026, 0.035]} />
        <meshBasicMaterial color="#7af0d8" transparent opacity={0.62} />
      </mesh>
      <mesh position={[-0.92, -0.78, 0.08]}>
        <boxGeometry args={[1.78, 0.28, 0.035]} />
        <meshBasicMaterial color="#0b8171" transparent opacity={0.22} />
      </mesh>
      {["ATLAS", "RISK", "BRIEF", "PORTFOLIO", "TERMINAL"].map((row, i) => (
        <SceneText key={row} position={[-1.15, 0.72 - i * 0.34, 0.08]} fontSize={0.14} color={i === 0 ? "#14d8b4" : "#8c9290"} fillOpacity={0.56}>
          {row}
        </SceneText>
      ))}
      {["VOL", "BETA", "DD"].map((metric, i) => (
        <SceneText key={metric} position={[0.08 + i * 0.42, -0.72, 0.12]} fontSize={0.09} color="#7af0d8" fillOpacity={0.44}>
          {metric}
        </SceneText>
      ))}
    </group>
  )
}
